
 <!-- <div class="row">   -->
  <!-- <div class="col-md-9">
    <img id="popUpImage" class="slider" [src]="productMainImage">
  </div>
  <div class="col-md-3">
  <button mat-mini-fab class="btn"  (click)="zoomin()">+</button>
  <button mat-mini-fab class="btn1" (click)="zoomout()">-</button>
  <button mat-button mat-dialog-close>Close</button>
</div> -->
<!-- <mat-dialog-actions>
  <button mat-button mat-dialog-close>Close</button>
</mat-dialog-actions> -->

<!-- </div> -->  
<div class="parent">
  <div class="buttons">
    <!-- <div class="zoom"> -->
      <button mat-mini-fab class="btn"  (click)="zoomin()">+</button>
      <button mat-mini-fab class="btn1" (click)="zoomout()">-</button> 
      <button mat-mini-fab mat-dialog-close class="close">x</button>
    <!-- </div> -->
    <!-- <div class="cls"><button mat-mini-fab mat-dialog-close class="close">x</button></div> -->
  </div>
  <div class="image-container" [style.transform]="'scale(' + zoomFactor + ')'">
    
    <img #myImage [src]="productMainImage" alt="Zoomable Image"  (load)="getImageSize(myImage)"/> 

</div> 



